import { BaseUrl } from "./baseUrls";

export async function uploadGeneralBaseData(formData: FormData) {
    const url = `${BaseUrl}/uploadGeneralBaseData`;
    return fetch(url, {
        method: 'POST',
        body: formData,
    });
}
